// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-popover-item {
    display: flex;
    margin-top: var(--space-and-half);
}

.notifications-popover-item__image {
    position: relative;
    width: 40px;
    height: 40px;
    margin-right: var(--space-half);
}
.notifications-popover-item__image__photo {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
}

.notifications-popover-item__image__photo__image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.notifications-popover-item__image__photo__image.icon-ball{
    font-size: 30px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: 40px;
    color: var(--white-color);
}
.notifications-popover-item__image__icon {
    position: absolute;
    width: 18px;
    height: 18px;
    bottom: -2px;
    right: -2px;
    overflow: hidden;
    border-radius: 50%;
    /* background: var(--secondary-color); */
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
}

.notifications-popover-item__image__icon .iconr-clap{
    background: var(--white-color);
    border-radius: 50%;
    border: 1px solid var(--new-green-color); 
}

.notifications-popover-item__image__icon .iconr-support{
    background: var(--white-color);
    border-radius: 50%;
    border: 1px solid var(--new-green-color); 
}

.notifications-popover-item__image__icon .iconr-funny{
    background: var(--white-color);
    border-radius: 50%;
    border: 1px solid var(--new-green-color); 
}

.notifications-popover-item__image__icon .iconr-red-card{
    background: var(--white-color);
    border-radius: 50%;
    border: 1px solid var(--new-green-color); 
}

.notifications-popover-item__image__icon .iconr-celebrate{
    background: var(--white-color);
    border-radius: 50%;
    border: 1px solid var(--new-green-color); 
}

.notifications-popover-item__image__icon .iconr-sad{
    background: var(--white-color);
    border-radius: 50%;
    border: 1px solid var(--new-green-color); 
}

.notifications-popover-item__image__icon__photo {
    color: var(--primary-very-dark-color);
}

.notifications-popover-item__content {
    cursor: pointer;
}
.notifications-popover-item__content__caption {}
p.notifications-popover-item__content__caption__text {
    color: var(--primary-dark-color) !important;
}
p.notifications-popover-item__content__caption__date {
    color: var(--basic-gray-color) !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/notifications/components/notification-popover-item/NotificationPopoverItemComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;AACA,+CAA+C;AAC/C;IACI,2CAA2C;AAC/C;AACA;IACI,yCAAyC;AAC7C","sourcesContent":[".notifications-popover-item {\n    display: flex;\n    margin-top: var(--space-and-half);\n}\n\n.notifications-popover-item__image {\n    position: relative;\n    width: 40px;\n    height: 40px;\n    margin-right: var(--space-half);\n}\n.notifications-popover-item__image__photo {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    overflow: hidden;\n    display: flex;\n}\n\n.notifications-popover-item__image__photo__image {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n.notifications-popover-item__image__photo__image.icon-ball{\n    font-size: 30px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: 40px;\n    color: var(--white-color);\n}\n.notifications-popover-item__image__icon {\n    position: absolute;\n    width: 18px;\n    height: 18px;\n    bottom: -2px;\n    right: -2px;\n    overflow: hidden;\n    border-radius: 50%;\n    /* background: var(--secondary-color); */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n}\n\n.notifications-popover-item__image__icon .iconr-clap{\n    background: var(--white-color);\n    border-radius: 50%;\n    border: 1px solid var(--new-green-color); \n}\n\n.notifications-popover-item__image__icon .iconr-support{\n    background: var(--white-color);\n    border-radius: 50%;\n    border: 1px solid var(--new-green-color); \n}\n\n.notifications-popover-item__image__icon .iconr-funny{\n    background: var(--white-color);\n    border-radius: 50%;\n    border: 1px solid var(--new-green-color); \n}\n\n.notifications-popover-item__image__icon .iconr-red-card{\n    background: var(--white-color);\n    border-radius: 50%;\n    border: 1px solid var(--new-green-color); \n}\n\n.notifications-popover-item__image__icon .iconr-celebrate{\n    background: var(--white-color);\n    border-radius: 50%;\n    border: 1px solid var(--new-green-color); \n}\n\n.notifications-popover-item__image__icon .iconr-sad{\n    background: var(--white-color);\n    border-radius: 50%;\n    border: 1px solid var(--new-green-color); \n}\n\n.notifications-popover-item__image__icon__photo {\n    color: var(--primary-very-dark-color);\n}\n\n.notifications-popover-item__content {\n    cursor: pointer;\n}\n.notifications-popover-item__content__caption {}\np.notifications-popover-item__content__caption__text {\n    color: var(--primary-dark-color) !important;\n}\np.notifications-popover-item__content__caption__date {\n    color: var(--basic-gray-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
